import MyClientAllocations from './MyClientAllocations';

export default MyClientAllocations;
